var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{attrs:{"type":"checkbox","id":`${_vm.modifierGroup.modifier_group}${_vm.modifier.upc}`,"disabled":!_vm.checked && _vm.maxedOut},domProps:{"checked":_vm.checked,"value":_vm.modifier},on:{"input":function($event){return _vm.handleModifierSelect($event, {
        ..._vm.modifier,
        modifier_group: _vm.modifierGroup.modifier_group,
      })}}}),_c('label',{class:_vm.sm && 'font-size-sm',attrs:{"for":`${_vm.modifierGroup.modifier_group}${_vm.modifier.upc}`}},[_vm._v(_vm._s(_vm.modifier.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }